import cx from "clsx";
import { Collection } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import {
  getResourceKey$TrackRestorePolicyJob,
  httpGet$TrackRestorePolicyJob,
} from "kreate-server/commands/TrackRestorePolicyJob/fetcher";
import React from "react";
import { MdCheck, MdClose, MdSync } from "react-icons/md";
import useSWR from "swr";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: Collection | null | undefined;
};

export default function SyncStatusViewer({
  className,
  style,
  collection,
}: Props) {
  const params = collection?.policyId
    ? { policyId: collection.policyId }
    : undefined;

  const { data } = useSWR(
    getResourceKey$TrackRestorePolicyJob(params),
    async () =>
      params
        ? await httpGet$TrackRestorePolicyJob(
            "/api/v1/restore-policies/track",
            params
          )
        : undefined,
    {
      refreshInterval: 10000, // auto refresh every 10 seconds
    }
  );

  return (
    <div
      className={cx(styles.container, className)}
      style={style}
      title={JSON.stringify(data)}
    >
      {(() => {
        switch (data?.status) {
          case "preparing":
            return (
              <Flex.Row
                className={styles.syncStatus}
                alignItems="center"
                gap="12px"
              >
                <MdSync className={styles.iconSyncing} size="24px" />
                <span>{"Syncing..."}</span>
              </Flex.Row>
            );
          case "processing":
            return (
              <Flex.Row
                className={styles.syncStatus}
                alignItems="center"
                gap="12px"
              >
                <MdSync className={styles.iconSyncing} size="24px" />
                <span>{`Syncing (${data.progress.done}/${data.progress.total})`}</span>
              </Flex.Row>
            );
          case "processed":
            return (
              <Flex.Row
                className={styles.syncStatus}
                alignItems="center"
                gap="12px"
              >
                <MdCheck className={styles.iconSuccess} size="24px" />
                <span>
                  {data.progress.failed ? `Synced (with errors)` : `Synced`}
                </span>
              </Flex.Row>
            );
          case "failed":
            return (
              <Flex.Row
                className={styles.syncStatus}
                alignItems="center"
                gap="12px"
              >
                <MdClose className={styles.iconFailed} size="24px" />
                <span>{`Sync failed`}</span>
              </Flex.Row>
            );

          default:
            return undefined;
        }
      })()}
    </div>
  );
}
